import EN from '../constants/en.json';

const localeTextTranslationsEn = { ...EN };

export default localeTextTranslationsEn;
